"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = require("../Box");

var _Button = require("../Button");

var _excluded = ["icon", "children", "size"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * A button with a slot for an icon. V3-only.
 */


var IconButton = function IconButton(_ref) {
  var icon = _ref.icon,
      children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  var buttonSize = _Button.BUTTON_SIZES[size];
  return /*#__PURE__*/_react.default.createElement(_Button.Button, _extends({
    justifyContent: "space-between",
    px: 0,
    pl: buttonSize.px / 2,
    pr: buttonSize.px,
    size: size
  }, rest), /*#__PURE__*/_react.default.createElement(Icon, {
    mr: buttonSize.px / 2,
    "aria-hidden": "true"
  }, icon), children, /*#__PURE__*/_react.default.createElement(_Box.Box, null));
};

exports.IconButton = IconButton;
IconButton.displayName = "IconButton";
var Icon = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "IconButton__Icon",
  componentId: "yl1gnf-0"
})(["> svg{display:block;}"]);